import React, { useState, useEffect, useContext } from "react";
import CustomTable from "../../../core/custom-table";
import { HTTP_METHODS, invokeApi, plainApi } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import { toast } from "react-toastify";
import { Box, Grid, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CustomButtonComponent from "../../../core/custom-button";
import FailedEngineFilter from "../analysis/failed-engine-analysis/failed-engine-filter";
import AttachmentModal from "../../../components/attachment-modal";
import AppContext from "../../../utils/context";
import {
  checkForUserLimit,
  getFileNameFromUrl,
  PAGE_LIMIT,
} from "../../../utils";
import { USER_LIMITS } from "../../../utils/constants";
import { FailedPartsHeaderConfig, HeaderConfig } from "./config";
import CustomModal from "../../../core/modal";
import { getFailedEngineFormConfig } from "../analysis/failed-engine-analysis/config";
import ThumbUpAltTwoToneIcon from "@mui/icons-material/ThumbUpAltTwoTone";
import ThumbDownOffAltTwoToneIcon from "@mui/icons-material/ThumbDownOffAltTwoTone";
import PreviewFormGenerator from "../../../core/preview-form-generator";
import { getFailedPartFormConfig } from "../analysis/failed-parts-analysis/config";
import moment from "moment";

const FailedPartAnalysisRequests = () => {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [engineModelList, setEngineModelList] = useState([]);
  const [listNumbers, setListNumber] = useState([]);
  const [viewForm, setViewForm] = useState({
    isOpen: false,
    data: {},
  });
  const [oemList, setOemList] = useState([]);
  const { userDetails = {} } = useContext(AppContext);
  const [filters, setFilters] = useState({
    page: 1,
    limit: PAGE_LIMIT,
    status: "PENDING",
    qualityApprover: userDetails?.id,
    sortBy: "-createdAt",
  });

  const ClickHandler = (type, data) => {
    if (type === "VIEW") {
      const oems = data?.oem?.map((ele) => ele.name);

      setViewForm({
        isOpen: true,
        data: {
          ...data,
          cutInEffectiveDate: moment(data.cutInEffectiveDate).format(
            "DD/MM/YYYY"
          ),
          oem: oems?.join(", "),
        },
      });
      setEngineModelList(data?.engineModel);
      setListNumber(data?.listNo);
    }
  };
  const updateFormStatus = (status) => {
    const { id } = viewForm.data;
    if (id) {
      invokeApi(
        HTTP_METHODS.PUT,
        `${HOSTNAME}${REST_URLS.FAILED_PART_ANALYSIS}/${id}`,
        {
          status: status,
        }
      )
        .then((res) => {
          if (res.message) {
            toast.error(res.message);
          } else {
            toast.success("Updated Sucessfully");
            setViewForm({
              isOpen: false,
              data: {},
            });
            loadData(filters);
          }
        })
        .catch((err) => console.error(err));
    }
  };
  const loadData = (filters) => {
    setIsLoading(true);
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.FAILED_PART_ANALYSIS}`,
      null,
      filters
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          setData(res);
        }
        setIsLoading(false);
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    loadData(filters);
  }, []);
  return (
    <div className="page-body">
      <div className=" view-detailed-ticket">
        <div>
          <p className="tab-name">Pending Requests</p>
          <p className="section-name">Failed parts analysis report</p>
        </div>
      </div>

      <div>
        <div className="si-hide-mobile">
          <CustomTable
            header={FailedPartsHeaderConfig(userDetails)}
            data={data.results || []}
            pageCount={data.totalPages}
            filters={filters}
            onClick={ClickHandler}
            onChange={(page) => {
              setFilters({
                ...filters,
                page,
              });
              loadData({
                ...filters,
                page,
              });
            }}
            filterCom={<FailedEngineFilter loadData={loadData} />}
            isLoading={isLoading}
          />
        </div>
      </div>

      {viewForm?.isOpen && (
        <CustomModal
          title="Failed Part"
          onClose={() => {
            setViewForm({
              isOpen: false,
              data: {},
            });
          }}
          contentClassName="pending-model"
        >
          {viewForm?.data?.status === "PENDING" && (
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <CustomButtonComponent
                variant="contained"
                color="success"
                sx={{ mr: 1 }}
                onClick={() => updateFormStatus("APPROVED")}
                startIcon={<ThumbUpAltTwoToneIcon />}
              >
                Approve
              </CustomButtonComponent>
              <CustomButtonComponent
                variant="contained"
                color="error"
                sx={{ ml: 1, mr: 3 }}
                onClick={() => updateFormStatus("REJECTED")}
                startIcon={<ThumbDownOffAltTwoToneIcon />}
              >
                Reject
              </CustomButtonComponent>
            </Box>
          )}

          <PreviewFormGenerator
            formConfig={getFailedPartFormConfig(oemList)}
            formValues={viewForm.data}
          />
          <Grid container>
            <Grid item md={6}>
              <p>Engine Models</p>
              {engineModelList?.length > 0 && (
                <div className="input-field-con" style={{ marginLeft: "0px" }}>
                  {engineModelList?.map((engine, index) => {
                    return (
                      <div
                        className={`chip-com-con purple-bg`}
                        style={{ width: "fit-content", marginRight: "1px " }}
                      >
                        <p>{engine} </p>
                      </div>
                    );
                  })}
                </div>
              )}
            </Grid>
            <Grid item md={6}>
              <p>List Numbers</p>
              {listNumbers?.length > 0 && (
                <div className="input-field-con" style={{ marginLeft: "0px" }}>
                  {listNumbers?.map((list, index) => {
                    return (
                      <div
                        className={`chip-com-con purple-bg`}
                        style={{ width: "fit-content", marginRight: "1px " }}
                      >
                        <p>{list} </p>
                      </div>
                    );
                  })}
                </div>
              )}
            </Grid>
          </Grid>
          <p>Attachments</p>
          {viewForm?.data?.attachments?.map((r, index) => {
            return (
              <div key={r.blobName + index}>
                {r.blobName ? (
                  <span>{r.blobName}</span>
                ) : (
                  <a href={r} target="_blank">
                    {getFileNameFromUrl(r)}
                  </a>
                )}
              </div>
            );
          })}
        </CustomModal>
      )}
    </div>
  );
};
export default FailedPartAnalysisRequests;
